import { render, staticRenderFns } from "./KycView.vue?vue&type=template&id=36ea7d30&"
import script from "./KycView.vue?vue&type=script&lang=js&"
export * from "./KycView.vue?vue&type=script&lang=js&"
import style0 from "./KycView.vue?vue&type=style&index=0&id=36ea7d30&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports